import React, { Component } from 'react'
import { Link, withRouter } from 'react-router-dom'
import constant from '../../constant'
import logo from './../../assets/images/logo.png'
export default withRouter(class Header extends Component {
    constructor(props) {
        super(props);
        this.state = {}
    }
    render() {
        console.log(this.props)
        return (

            // <div className="loader-container">
            //     <div className="loader-circle">
            //         <div className="loader">
            //             <div className="loader-dot"></div>
            //             <div className="loader-dot"></div>
            //             <div className="loader-dot"></div>
            //             <div className="loader-dot"></div>
            //             <div className="loader-dot"></div>
            //             <div className="loader-dot"></div>
            //         </div>
            //     </div>
            // </div>



            <header className="header-area header-area-2">
                <div className="header-menu-wrapper">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="menu-full-width">
                                    <div className="logo">
                                        <Link to='/'><img src={logo} alt="logo" /></Link>
                                    </div>
                                    <div className="main-menu-content">
                                        <nav>
                                            <ul>
                                                <li>
                                                    <Link to='/'>Home</Link>
                                                </li>
                                                <li>
                                                    <a >Product & Services <i className="la la-angle-down"></i></a>
                                                    <ul className="dropdown-menu-item">
                                                        <li><a id='linked-in' href={constant.component.JobPosting.url}>Job Posting</a></li>
                                                        <li><a id='linked-in' target="_blank" href="javascript:void(0)">CRM</a></li>
                                                        <li><a id='linked-in' target="_blank" href="javascript:void(0)">Corporate Training</a></li>
                                                        <li><a id='linked-in' target="_blank" href="javascript:void(0)">Campus Hiring</a></li>

                                                        {/* <li><a target="_blank" href="https://www.mounttalent.com/hrms/">Early Salary</a></li>
                                                        <li><a target="_blank" href={constant.component.SalesEnquiry.url}>Bulk Hiring</a></li>
                                                        <li><a target="_blank" href="https://www.mounttalent.com/hrms/">HRMS System</a></li> */}
                                                        {/* <li><a href="">Recruiter Branding Solutions</a></li> */}
                                                        {/* <li><a href="">Referral Solutions</a></li> */}
                                                    </ul>
                                                </li>

                                                {/* <li>
                                                    <a href={constant.component.Outplacements.url}>Outplacement</a>
                                                </li> */}
                                            </ul>
                                        </nav>
                                    </div>
                                    <div className="logo-right-content">
                                        <ul className="author-access-list">
                                            <li><Link className="collnow-btn"> <span><i className="la la-headphones"> </i>
                                            </span><span className='heder-phone-nbr'> Indian Sales Support (9:30 AM to 6:30PM) <span className='pgone'>+91- 7353 466 466</span></span></Link></li>
                                            {/* <li>
                                                <Link id='linked-in' to={constant.component.login.url}><i className="la la-sign-in"> </i> Login</Link>
                                                <span className="or-text"></span>
                                            </li> */}
                                            <li>
                                                <Link id='linked-in' to={constant.component.SalesEnquiry.url} className="sales-enquiry">
                                                    <span className="la la-plus enquiry"></span>
                                                    Corporate Enquiry
                                                </Link>
                                            </li>
                                            <li>
                                                <a className='JobSeeker-link' href="https://jobzshala.com/?search=true" target='_blank'><i class="la la-external-link"></i> JobSeeker </a></li>
                                        </ul>
                                        <div className="side-menu-open">
                                            <span className="menu__bar"></span>
                                            <span className="menu__bar"></span>
                                            <span className="menu__bar"></span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="side-nav-container">
                    <div className="humburger-menu">
                        <div className="humburger-menu-lines side-menu-close"></div>
                    </div>
                    <div className="side-menu-wrap">
                        <ul className="side-menu-ul">
                            <li>
                                <a href="#">Home</a>
                            </li>
                            <li>
                                <a href="#">Products <i className="la la-angle-down"></i></a>
                                <ul className="dropdown-menu-item">
                                    <li><a id='linked-in' href={constant.component.JobPosting.url}>Packages</a></li>
                                    <li><a id='linked-in' href={constant.component.directjobpost.url}>Job Posting</a></li>
                                    <li><a id='linked-in' target="_blank" href={"https://www.jobzshala.com/contractual-staffing"}>Contractual Staffing</a></li>
                                    <li><a id='linked-in' target="_blank" href="https://jobzshala.com/hrms">H R Management System</a></li>
                                    <li><a id='linked-in' target="_blank" href='https://jobzshala.com/payroll-automation'>Payroll Automation</a></li>
                                    <li><a id='linked-in' target="_blank" href='https://jobzshala.com/marketing-technology'>Marketing Technology Solution</a></li>
                                    <li><a id='linked-in' target="_blank" href='https://jobzshala.com/startup-incubation'>Startup Incubation</a></li>
                                    <li><a id='linked-in' target="_blank" href='https://jobzshala.com/full-time-hiring'>Full Time Hiring</a></li>
                                    {/* <li><a href="">Recruiter Branding Solutions</a></li> */}
                                    {/* <li><a href="">Referral Solutions</a></li> */}
                                </ul>
                            </li>
                            <li>
                                <a href="/">Contact Us</a>
                            </li>
                        </ul>
                        <div className="side-nav-button">
                            <Link to={'/'}>Login</Link>
                            <span className="or-text">or</span>
                            <Link to={constant.component.login.url}>Login</Link>
                            <Link to={''} className="theme-btn">Sales Enquiry</Link>
                        </div>
                    </div>
                </div>
            </header>

        )
    }
}
)